// Footer Accordion Function
// ===================================
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth < 575) {
    document.querySelectorAll(".footer-block__heading").forEach((heading) => {
      heading.addEventListener("click", function () {
        this.parentElement.classList.toggle("open");
      });
    });
  }
});

// Footer whatsapp button
// ===================================
window.addEventListener('scroll', function() {
  var whatsappBtn = document.getElementById('whatsappBtn');
  
  // Show button after scrolling down 300px from the top
  if (window.scrollY > 300) {
      whatsappBtn.classList.add('show');
  } else {
      whatsappBtn.classList.remove('show');
  }
});